import { createActionConst } from '../../../../utils/action.utils';

const COMPANY_TOOLS_CATEGORIES_NAMESPACE = 'COMPANY_TOOLS_CATEGORYS';

export const SETUP_COMPANY_TOOLS_CATEGORIES = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'SETUP_COMPANY_TOOLS_CATEGORIES',
);

export const CREATE_COMPANY_TOOLS_CATEGORY = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'CREATE_COMPANY_TOOLS_CATEGORY',
);
export const UPDATE_COMPANY_TOOLS_CATEGORY = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'UPDATE_COMPANY_TOOLS_CATEGORY',
);
export const DELETE_COMPANY_TOOLS_CATEGORY = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'DELETE_COMPANY_TOOLS_CATEGORY',
);

export const STORE_IS_FETCHED = createActionConst(COMPANY_TOOLS_CATEGORIES_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(COMPANY_TOOLS_CATEGORIES_NAMESPACE, 'CLEAR_IS_FETCHED');

export const STORE_COMPANY_TOOLS_CATEGORIES = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'STORE_COMPANY_TOOLS_CATEGORIES',
);
export const CLEAR_COMPANY_TOOLS_CATEGORIES = createActionConst(
  COMPANY_TOOLS_CATEGORIES_NAMESPACE,
  'CLEAR_COMPANY_TOOLS_CATEGORIES',
);

export const SAVE_COMPANY_TOOLS_CATEGORY_SOCKET = 'saveCompanyToolsCategory';
export const DELETE_COMPANY_TOOLS_CATEGORY_SOCKET = 'deleteCompanyToolsCategory';
